/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../common/controller/list-helper.service';
import {Component, Inject, OnInit} from '@angular/core';

import {PERMISSIONS} from '../../components/auth/auth-constants';
import {ReportScheduleResource} from '../../components/api/resources/resource/report-schedule.resource';
import {LocalUserPermissions} from '../../components/session/local-user-permissions';

@Component({
  standalone: false,
  selector: 'adn-report-schedule-route-page',
  template: `
    <adn-report-schedule-list-page
      *ngIf="list"
      [list]="list">
    </adn-report-schedule-list-page>
  `
})
export class ReportScheduleRoutePageComponent implements OnInit {
  list: any = {};

  constructor(
    private readonly adnListHelper: AdnListHelperService,
    @Inject(ReportScheduleResource) private readonly ReportSchedule: any,
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any
  ) {
  }

  ngOnInit(): void {
    const readOnly = !this.LocalUserPermissions.hasNetwork(PERMISSIONS.manageReportTemplates.apiKey)
      && !this.LocalUserPermissions.hasAny(PERMISSIONS.runReports.apiKey);
    this.adnListHelper.setUpList(this.list, this.ReportSchedule, readOnly, 'fullReportScheduleList', {
      baseTable: 'reportSchedule'
    });
  }
}
